import { createContext } from 'react'

export const LayoutOverlayContext = createContext({
  showGretaAIChat: false,
  showProductFruits: false,
  withModalsTray: false,
})
